import {shallowEqual} from 'react-redux';
import {assert} from 'assert-ts';
import type {ThesaurusId} from 'domainTypes';
import {selectSettingsPreferredLocale} from 'services/settings';
import {useAppSelector} from 'store/hooks';
import type {ThesaurusesMap} from '../types';
import {thesaurusApi} from '../thesaurusApi';

/**
 * Resolves the given thesaurus ids to their loaded thesauruses from the cache.
 * Assumes the needed thesauruses have been loaded.
 */
export const useThesauruses = (ids: ThesaurusId[]): ThesaurusesMap => {
  const language = useAppSelector(selectSettingsPreferredLocale);

  return useAppSelector(state => {
    return ids.reduce<ThesaurusesMap>((acc, id) => {
      acc[id] = assert(
        thesaurusApi.endpoints.getThesaurus.select({id, language})(state).data,
        `useThesauruses: missing thesaurus for id: ${id}`,
        {id},
      );
      return acc;
    }, {} as ThesaurusesMap);
  }, shallowEqual);
};
